// 财务管理路由
export default {
    path: 'finance',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '财务管理'},
    children:[{
        path: 'activity',
        component: () => import('@/components/RouterView'),
        redirect: 'noRedirect',
        children: [{
            path: 'receivables',
            component: () => import('@/views/manage/finance/activity/receivables'),
            meta: {title: '演出收款信息'},
        },{
            path: 'paymentrequest',
            component: () => import('@/views/manage/finance/activity/paymentrequest'),
           // meta: {title: '演出结款申请'},
        },{
            path: 'paymentrequestlist',
            component: () => import('@/views/manage/finance/activity/paymentrequestlist'),
           // meta: {title: '结款单'},
        }]
    },{
        path: 'raise',
        component: () => import('@/components/RouterView'),
        redirect: 'noRedirect',
        children: [{
            path: 'receivables',
            component: () => import('@/views/manage/finance/raise/receivables'),
            meta: {title: '众筹收款信息'},
        },{
            path: 'settlement',
            component: () => import('@/views/manage/finance/raise/settlement'),
            meta: {title: '众筹结款申请'},
        }]
    },{
        path: 'contract',
        component: () => import('@/components/RouterView'),
        redirect: 'noRedirect',
        children: [{
            path: 'center',
            component: () => import('@/views/manage/finance/contract/center'),
            meta: {title: '合同中心'},
        },{
            path: 'company',
            component: () => import('@/views/manage/finance/contract/company'),
            // meta: {title: '签约公司'}, 菜单不显示, 从合同中心跳转
        },{
            path: 'company/form',
            component: () => import('@/views/manage/finance/contract/company/form'),
        },{
            path: 'plan',
            component: () => import('@/views/manage/finance/contract/plan'),
            // meta: {title: '签署合同'}, 合作方案与签署流程页
        },{
            path: 'templateDoc',
            component: () => import('@/views/manage/finance/contract/templateDoc'),
            // meta: {title: '合同模板底稿'}, 模板底稿页 (P0-5 入口; P1-2 完整化正文占位)
        },{
            path: 'detail',
            component: () => import('@/views/manage/finance/contract/detail'),
            // meta: {title: '合同详情'}, 合同详情页
        }]
    },{
        path: 'invoice',
        component: () => import('@/components/RouterView'),
        redirect: 'noRedirect',
        children: [{
            path: 'list',
            component: () => import('@/views/manage/finance/invoice/list'),
            meta: {title: '发票中心'},
        }]
    }]
}